import { useLang } from "@/context/LanguageContext";
import { ExternalLink, Info } from "lucide-react";

const RESOURCES = [
  // International & Central Authority resources
  { category: "institutions", name: "Hague Conference on Private International Law (HCCH)", url: "https://www.hcch.net" },
  { category: "institutions", name: "HCCH — 1980 Child Abduction Convention (full text and status table)", url: "https://www.hcch.net/en/instruments/conventions/full-text/?cid=24" },
  { category: "institutions", name: "U.S. Department of State — International Parental Child Abduction", url: "https://travel.state.gov/content/travel/en/International-Parental-Child-Abduction.html" },
  { category: "institutions", name: "U.S. Department of State — Office of Children's Issues", url: "https://travel.state.gov/content/travel/en/international-travel/before-you-go/travelers-with-special-considerations/us-children-abroad.html" },
  { category: "institutions", name: "United Nations Office of the High Commissioner for Human Rights", url: "https://www.ohchr.org" },
  { category: "institutions", name: "UNICEF — Children's Rights", url: "https://www.unicef.org" },
  { category: "institutions", name: "Council of Europe — Family Law", url: "https://www.coe.int" },

  // Academic & research
  { category: "academic", name: "SSRN — Family Law & Private International Law", url: "https://www.ssrn.com" },
  { category: "academic", name: "HeinOnline — Family Law Journals", url: "https://home.heinonline.org" },
  { category: "academic", name: "International Journal of Law, Policy and the Family (Oxford)", url: "https://academic.oup.com/lawfam" },
  { category: "academic", name: "University of Dayton School of Law", url: "https://udayton.edu/law" },

  // Professional bar / ADR / mediation associations
  { category: "professional", name: "American Bar Association — Section of Family Law", url: "https://www.americanbar.org/groups/family_law/" },
  { category: "professional", name: "American Bar Association — Section of Dispute Resolution", url: "https://www.americanbar.org/groups/dispute_resolution/" },
  { category: "professional", name: "Association for Conflict Resolution (ACR)", url: "https://acrnet.org" },
  { category: "professional", name: "Academy of Professional Family Mediators (APFM)", url: "https://apfmnet.org" },
  { category: "professional", name: "International Academy of Family Lawyers (IAFL)", url: "https://www.iafl.com" },
  { category: "professional", name: "International Bar Association — Family Law Committee", url: "https://www.ibanet.org" },
  { category: "professional", name: "MiKK — International Mediation Center for Family Conflict and Child Abduction", url: "https://www.mikk-ev.de" },
];

export default function Research() {
  const { t } = useLang();
  const groups = ["institutions", "academic", "professional"];
  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-20" data-testid="research-page">
      <h1 className="text-4xl sm:text-5xl font-bold">{t.research.title}</h1>
      <p className="mt-4 text-slate-300 max-w-3xl">{t.research.sub}</p>

      <div
        className="mt-6 rounded-xl border border-blue-500/30 bg-blue-500/5 p-4 flex items-start gap-3 max-w-3xl"
        data-testid="research-references-note"
      >
        <Info className="w-4 h-4 mt-0.5 text-blue-300 flex-shrink-0" />
        <p className="text-sm text-slate-300 leading-relaxed">{t.research.references_not_endorsements}</p>
      </div>

      <div className="mt-12 space-y-12">
        {groups.map((g) => (
          <div key={g}>
            <h2 className="text-xl font-semibold text-blue-300">{t.research.categories[g]}</h2>
            <div className="mt-4 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
              {RESOURCES.filter((r) => r.category === g).map((r, i) => (
                <a key={i} href={r.url} target="_blank" rel="noreferrer noopener"
                   className="card-mift p-5 group" data-testid={`research-${g}-${i}`}>
                  <div className="text-slate-100 font-medium leading-snug">{r.name}</div>
                  <div className="mt-3 inline-flex items-center gap-1.5 text-sm text-blue-300 group-hover:text-blue-200">
                    {t.research.visit} <ExternalLink className="w-3.5 h-3.5" />
                  </div>
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
